import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

import { api } from '../lib/api-client';
import { syncFireAndForget } from '../lib/sync';

interface IntroState {
  /** True once the user has walked through Screen 4 — either by setting a safe word or by skipping. */
  completed: boolean;
  setCompleted: (val: boolean) => void;
  hydrate: (completed: boolean) => void;
  reset: () => void;
}

const initial = { completed: false };

export const useIntroStore = create<IntroState>()(
  persist(
    (set) => ({
      ...initial,
      setCompleted: (completed) => {
        set({ completed });
        syncFireAndForget(() => api.me.updateUser({ introCompleted: completed }));
      },
      hydrate: (completed) => set({ completed }),
      reset: () => set({ ...initial }),
    }),
    {
      name: 'llura.intro',
      storage: createJSONStorage(() => localStorage),
      version: 1,
    },
  ),
);
